import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { EnvService } from "./env.service";
import { catchError } from "rxjs/operators";
import { GoogleAnalyticsService } from "./google-analytics.service";

export class BaseUrlInterceptorService implements HttpInterceptor {
  constructor(
    private baseUrl: string,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.indexOf("assets") >= 0) {
      return next.handle(req);
    }

    const offset = new Date().getTimezoneOffset()

    const apiReq = req.clone({
      url: `${this.baseUrl}/${req.url}`,
      headers: req.headers
        .set("ambiente", EnvService.ambienteHeader)
        .set("cliente", EnvService.cliente)
        .set("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone)
        .set("timezone-offset", (offset > 0 ? "-" : "") + String(Math.abs(offset))),
    });
    return next.handle(apiReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if(error.status >= 400) {
          let errorMessage = error.error

          if (errorMessage && typeof errorMessage === 'object') {
            errorMessage = errorMessage.detail
              || errorMessage.message
              || JSON.stringify(errorMessage)
          }

          this._googleAnalyticsService.emitEvent('api-error', {
            errorStatus: error.status,
            errorUrl: apiReq.urlWithParams,
            errorMessage: (errorMessage || error.message || '').substring(0, 300),
            page_location: window.location.href
          })
        }
        return throwError(error)
      })
    );
  }
}
